import { render, staticRenderFns } from "./BookSelection.vue?vue&type=template&id=0b628bc3&"
import script from "./BookSelection.vue?vue&type=script&lang=js&"
export * from "./BookSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports